import { API_URL } from "../variables";

// Evento global que App escucha para cerrar sesión cuando el token vence.
export const UNAUTHORIZED_EVENT = "ashara:unauthorized";

export class ApiError extends Error {
    constructor(message, status, body) {
        super(message);
        this.status = status;
        this.errors = body?.errors || [];
        this.details = body?.details;
    }
}

const buildQuery = (query) => {
    if (!query) return "";
    const params = new URLSearchParams();
    Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") params.append(key, value);
    });
    const text = params.toString();
    return text ? `?${text}` : "";
};

// Llama a ashara-admin-api y devuelve `data` del envoltorio { success, message, data }.
// Si la respuesta falla lanza ApiError con el mensaje del backend.
export async function apiRequest(path, { method = "GET", body, query, token, withMessage = false } = {}) {
    const isForm = typeof FormData !== "undefined" && body instanceof FormData;
    const headers = {};
    if (body !== undefined && !isForm) headers["Content-Type"] = "application/json";
    if (token) headers.Authorization = `Bearer ${token}`;

    let response;
    try {
        response = await fetch(`${API_URL}${path}${buildQuery(query)}`, {
            method,
            headers,
            body: body === undefined ? undefined : isForm ? body : JSON.stringify(body),
        });
    } catch {
        throw new ApiError("No se pudo conectar con el servidor", 0, null);
    }

    const json = await response.json().catch(() => null);

    if (!response.ok || json?.success === false) {
        if (response.status === 401 && token) {
            window.dispatchEvent(new Event(UNAUTHORIZED_EVENT));
        }
        let message = json?.message || `Error ${response.status}`;
        if (Array.isArray(json?.errors) && json.errors.length) {
            message = `${message}: ${json.errors.join(", ")}`;
        }
        throw new ApiError(message, response.status, json);
    }

    const data = json?.data ?? null;
    return withMessage ? { data, message: json?.message } : data;
}

// Envuelve una llamada para usarla dentro de createAsyncThunk:
// pasa el token del store y convierte los errores en rejectWithValue(mensaje).
export const withApi = (request) => async (arg, thunkApi) => {
    try {
        const token = thunkApi.getState()?.auth?.token;
        return await request(arg, { token, getState: thunkApi.getState });
    } catch (error) {
        return thunkApi.rejectWithValue(error?.message || "Error inesperado");
    }
};

// Roles efectivos del empleado (admin siempre pasa, igual que en la API).
export const hasRole = (employee, ...roles) => {
    const current = [...(employee?.roles || []), ...(employee?.isAdmin ? ["admin"] : [])];
    return current.includes("admin") || roles.some((role) => current.includes(role));
};
